// src/components/QaAlert.js
export default function QaAlert({
  id,
  message,
  variant = 'error', // 'error' | 'success' | 'info'
  dataQa = 'qa-alert',
}) {
  const visible = Boolean(message);
  const base = 'rounded-lg px-4 py-3 text-sm mb-4';
  const variants = {
    error:   'bg-red-50 text-red-700 border border-red-200',
    success: 'bg-green-50 text-green-700 border border-green-200',
    info:    'bg-blue-50 text-blue-700 border border-blue-200',
  };
  const role = variant === 'error' ? 'alert' : 'status'; // optional a11y tweak
  const cls = `${base} ${variants[variant] || variants.error}`;

  return (
    <div
      id={id}
      data-qa={dataQa}
      role={role}
      className={visible ? cls : 'sr-only'}
    >
      {message || ''}
    </div>
  );
}
